import {
    EDIT_PRODUCT_FAILED,
    EDIT_PRODUCT_LOADING,
    EDIT_PRODUCT_SUCCESS,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    status: null,
  };
  
  export const editProductReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any, status:any }
  ) => {
    switch (action.type) {
      case EDIT_PRODUCT_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
          status: null,
        };
      case EDIT_PRODUCT_SUCCESS:
        return {
          ...state,
          loading: false,
          status: action.status,
        };
      case EDIT_PRODUCT_FAILED:
        return {
          ...state,
          loading: false,
          error: action.error,
          status: null,
        };
     
      default:
        return state;
    }
  };
  